import { Injectable } from '@angular/core';
import { EnvironmentService } from '../environment.service';

@Injectable({
  providedIn: 'root'
})
export class FilesService {
  constructor(private environmentService: EnvironmentService) {}

  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        const pdfBlob = reader.result as string;
        const base64String = pdfBlob.split(',')[1];
        resolve(base64String);
      };
      reader.readAsDataURL(blob);
    });
  }

  async convertAndDownloadPdf(pdf: Blob, fileName?: string): Promise<boolean> {
    const isWebview = this.environmentService.isReactNativeWebView;
    if (isWebview) {
      try {
        console.log(
          'Running in WebView, converting to Base64 and posting message...'
        );
        const base64Pdf = await this.blobToBase64(pdf);
        this.environmentService.postDownloadPdfMessage(base64Pdf, fileName);
        console.log('Message posted to React Native WebView.');
        return true;
      } catch (error) {
        console.error(
          'Error converting Blob to Base64 or posting message:',
          error
        );
        return false;
      }
    } else {
      console.log('Running in standard browser, using Blob URL download...');
      try {
        const url = window.URL.createObjectURL(pdf);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => window.URL.revokeObjectURL(url), 100);
        console.log('Blob URL download initiated.');
        return true;
      } catch (error) {
        console.error('Error initiating Blob URL download:', error);
        return false;
      }
    }
  }
}
